import { render } from "./XTabGroup.vue?vue&type=template&id=2e740ab9&scoped=true"
import script from "./XTabGroup.vue?vue&type=script&lang=js"
export * from "./XTabGroup.vue?vue&type=script&lang=js"

import "./XTabGroup.vue?vue&type=style&index=0&id=2e740ab9&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e740ab9"]])

export default __exports__